import angular from 'angular';

import Autocomplete from './autocomplete/autocomplete.component';
import BackdropOverlay from './backdrop-overlay/bd-overlay.component';
import BackdropRail from './backdrop-rail/bd-rail.component';
import BackdropRow from './backdrop-row/bd-row.component';
import BackdropTitle from './backdrop-title/bd-title.component';
import Card from './card/card.component';
import CardGhost from './card-ghost/card-ghost.component';
import CarSelect from './car-select/car-select.component';
import Changelog from './changelog/changelog.component';
import Comment from './comment/comment.component';
import Datepicker from './datepicker/datepicker.component';
import Dialog from './dialog/dialog.component';
import File from './file/file.component';
import InfoBox from './info-box/info.component';
import Gallery from './gallery/gallery.component';
import LazyLoadingDirective from './lazy-loading/lazy-loading.directive';
import ModalOverlay from './modal-overlay/modal-overlay.component';
import Navbar from './navbar/navbar.component';
import NavigationDrawer from './navigation-drawer/nav-drawer.component';
import Notifications from './notifications/notifications.component';
import Overlay from './overlay/overlay.component';
import PasswordChange from './password-change/password-change.component';
import PagePreloader from './page-preloader/page-preloader.component';
import ProfileImage from './profile-image/profile-image.component';
import RichTextEditorComponent from './rich-text-editor/editor.component';
import UserName from './user-name/user-name.component';
import UserSelect from './user-select/user-select.component';
import Select from './select/select.component';
import StaticResource from './static-resource/static-resource.component';
import StaticLink from './static-link/static-link.component';
import Table from './table/table.component';
import Tag from './tag/tag.component';
import Toast from './toast/toast.component';
import UpdateBanner from './update-banner/update-banner.component';
import IconComponent from './icons/icons.component';
import RailComponent from './rail/rail.component';

const DEPENDENCIES = [
  Autocomplete,
  BackdropOverlay,
  BackdropRail,
  BackdropRow,
  BackdropTitle,
  Card,
  CardGhost,
  CarSelect,
  Changelog,
  Comment,
  Datepicker,
  Dialog,
  File,
  Gallery,
  IconComponent,
  InfoBox,
  LazyLoadingDirective,
  ModalOverlay,
  Navbar,
  NavigationDrawer,
  Notifications,
  Overlay,
  PagePreloader,
  PasswordChange,
  ProfileImage,
  RailComponent,
  RichTextEditorComponent,
  UserName,
  UserSelect,
  Select,
  StaticLink,
  StaticResource,
  Table,
  Tag,
  Toast,
  UpdateBanner,
];

export default angular.module('autoboard.ui-components', DEPENDENCIES)
  .name;
